import { render, staticRenderFns } from "./recibo-pagamento-escola-esca-nota-credito.vue?vue&type=template&id=1ea2e9ab&scoped=true&"
import script from "./recibo-pagamento-escola-esca-nota-credito.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-escola-esca-nota-credito.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-escola-esca-nota-credito.vue?vue&type=style&index=0&id=1ea2e9ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea2e9ab",
  null
  
)

export default component.exports